import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { Inventory } from "@onmo/graphql/graphql";

type IShopItem = {
  selectedInventory?: Inventory;
  openBundle?: Inventory;
};

const initialState: IShopItem = {
  selectedInventory: undefined,
  openBundle: undefined,
};

export const resetPopupState = createAction("popup/resetState");

export const popupSlice = createSlice({
  name: "shop",
  initialState: initialState,
  reducers: {
    setSelectedInventory: (
      state,
      action: PayloadAction<{ selectedInventory?: Inventory }>,
    ) => {
      state.selectedInventory = action.payload.selectedInventory;
    },
    setOpenBundle: (
      state,
      action: PayloadAction<{ openBundle?: Inventory }>,
    ) => {
      state.openBundle = action.payload.openBundle;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetPopupState, () => initialState);
  },
});

// Action creators are generated for each case reducer function
export const { setSelectedInventory, setOpenBundle } = popupSlice.actions;

export default popupSlice.reducer;
